"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SafeCast__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var SafeCast__factory_1 = require("./SafeCast__factory");
Object.defineProperty(exports, "SafeCast__factory", { enumerable: true, get: function () { return SafeCast__factory_1.SafeCast__factory; } });
